import { ModalId } from "../../../../../enums/modalId";
import { setOpenedModalId } from "../../../../../redux/slice/modalSlice";
import store from "../../../../../redux/store/store";

export const uploadClick = (csv_path?: string) => {
  store.dispatch(
    setOpenedModalId({
      id: ModalId.NAR_INGESTION_RE_UPLOAD_MODAL,
      metaData: {
        csv_path,
      },
    }),
  );
};
